<template>
  <div>
    <img style="width: 100%;height:450px ;position: absolute;" mode="aspectFill" src="../assets/img/account_bg.png"/>
    <div style="position: relative;z-index: 10;width: 100%;padding-top: 150px;font-size: 32px;font-weight: 500;text-align: center;margin-bottom: 50px">My Account</div>
    <div style="position: relative;z-index: 10;width: 100%;display: flex;justify-content: center;">
      <div style="display: flex;justify-content: center;align-items: center;width: 1200px;box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);margin-bottom: 50px">
        <div style="width: 300px;height: 570px;background-color: #f8f8f8;padding-top: 40px">
          <img style="width: 120px;height: 120px;margin-left: 90px" mode="aspectFill" src="../assets/img/account_avatar.png"/>
          <div style="font-size: 18px;font-weight: 400;text-align: center;margin-top: 20px">{{userInfo.username}}</div>
          <div style="width: 200px;height:40px;background-color: #FB9348;color: white;border-radius: 8px;display: flex;justify-content: center;align-items: center;margin:30px auto">
            <img style="width: 24px;height: 24px" mode="aspectFill" src="../assets/img/account_idcard.png"/>
            <div style="font-size: 16px;font-weight: 400;margin-left: 10px">My Account</div>
          </div>
        </div>
        <div style="width: 900px;height: 570px;background-color: white;padding-top: 40px">
          <div style="font-size: 18px;font-weight: 500;margin-left: 40px;padding-bottom: 30px;border-bottom: 1px solid #c6c6c6">Account Info</div>
          <div style="margin-left: 40px;padding-top: 20px;padding-bottom: 40px;border-bottom: 1px solid #c6c6c6">
            <div style="display: flex;margin-top: 20px">
              <div style="width: 100px;color: #666666;font-size: 14px;font-weight: 400">Name:</div>
              <div style="font-size: 14px;font-weight: 400">{{userInfo.username}}</div>
            </div>
            <div style="display: flex;margin-top: 20px">
              <div style="width: 100px;color: #666666;font-size: 14px;font-weight: 400">Email:</div>
              <div style="font-size: 14px;font-weight: 400">{{userInfo.email}}</div>
            </div>
            <div style="display: flex;margin-top: 20px">
              <div style="width: 100px;color: #666666;font-size: 14px;font-weight: 400">Cell Phone:</div>
              <div style="font-size: 14px;font-weight: 400">{{userInfo.phone}}</div>
            </div>
            <div style="display: flex;margin-top: 20px">
              <div style="width: 100px;color: #666666;font-size: 14px;font-weight: 400">Name of your Organization:</div>
              <div style="font-size: 14px;font-weight: 400">{{userInfo.unitName}}</div>
            </div>
            <div style="display: flex;margin-top: 20px">
              <div style="width: 100px;color: #666666;font-size: 14px;font-weight: 400">Professional title:</div>
              <div style="font-size: 14px;font-weight: 400">{{userInfo.title}}</div>
            </div>
            <div style="display: flex;margin-top: 20px">
              <div style="width: 100px;color: #666666;font-size: 14px;font-weight: 400">Address:</div>
              <div style="font-size: 14px;font-weight: 400">{{userInfo.address}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo:{},
      userId:''
    }
  },
  mounted() {
    this.userId = localStorage.getItem("userId");
    this.getUserInfo()
  },
  methods: {
    getUserInfo(){
      this.$http.get("/gene/user/"+this.userId)
          .then(res => {
            this.userInfo = res.data.data
          })
    },
  }
}
</script>

<style scoped>

</style>
